const THEME_KEY = "theme";

export const getStoredTheme = () => {
  try {
    return localStorage.getItem(THEME_KEY) === "dark" ? "dark" : "light";
  } catch (error) {
    return "light";
  }
};

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle("dark", theme === "dark");
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch (error) {
    // Storage can be blocked; the theme still applies for this visit.
  }
};

export const applyStoredTheme = () => {
  document.documentElement.classList.toggle("dark", getStoredTheme() === "dark");
};
